import WebAdminRouter from "./web/admin";
const WebRouter = [
    {
        path: '/web',
        redirect: () => {
            return '/web/admin'
        }
    },{
        path: '/home',
        redirect: () => {
            return '/web/admin'
        }
    },
    // {
    //     path: '/web/index',
    //     component: () =>
    //         import ('../views/web/index'),
    //     meta: {
    //         title: '首页',
    //         isLogin: false // 是否需要登录才能访问
    //     }
    // },
    {
        path: '/web/version',
        component: () =>
            import ('../views/web/version'),
        meta: {
            title: '版本更新',
            isLogin: false // 是否需要登录才能访问
        }
    },
    {
        path: '/web/help',
        component: () =>
            import ('../views/web/help'),
        meta: {
            title: '帮助中心',
            isLogin: false // 是否需要登录才能访问
        }
    },
    {
        path: '/web/login',
        component: () =>
            import ('../views/web/login'),
        meta: {
            title: '登录',
            needLogin: false, // 是否需要登录才能访问
            isLogin: true // 是否需要登录才能访问
        }
    },
    {
        path: '/tiaoz',
        component: () =>
            import ('../views/web/tiaoz'),
        meta: {
            title: '跳转中',
            needLogin: false, // 是否需要登录才能访问
            isLogin: true // 是否需要登录才能访问
        }
    },
    //  超管
    {
        path: '/web/admin',
        component: () =>
            import ('../views/web/home'),
        children: WebAdminRouter,
    },
]
export default WebRouter